export default {"src":"/_next/static/media/qrcode-circle-color.f65ba93b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};